// init app action type
export const SET_INIT_APP_INFO = 'SET_INIT_APP_INFO';
